export default __webpack_public_path__ + "static/media/Gon of Four Trigrams.7cc0367f.png";